import { FC } from "react";
import { Contract } from "../../../lib/src/api/partner/models/Contract";
import { Card } from "../../../lib/src/components/Card";
import { Button } from "../../../lib/src/components/form/Button";
import { faCancel, faRefresh } from "@fortawesome/free-solid-svg-icons";
import { useApiClient } from "../../../lib/src/api";
import { config } from "../config";
import { useRealtimeDeployments } from "./deployments/RealtimeDeployments";
import { useRefresh } from "../../../lib/src/components/RefreshController";

export const EntityContractControls: FC<{ entity: { contracts: Contract[] } }> = (props) => {
  const { partnerClient } = useApiClient(config)
  const { awaitNextDeploymentFinished } = useRealtimeDeployments()!
  const reload = useRefresh()
  async function cancelContract(contract: Contract) {
    const deployment = await partnerClient.cancelContract(contract.id)
    if (!deployment.success) {
      return
    }
    await awaitNextDeploymentFinished(deployment.data.id)
    reload()
  }
  async function reactivateContract(contract: Contract) {
    const deployment = await partnerClient.reactivateContract(contract.id)
    if (!deployment.success) {
      return
    }
    await awaitNextDeploymentFinished(deployment.data.id)
    reload()
  }
  return <Card title={'Cancel'}>
    {props.entity.contracts.map((contract, i) => <div key={i} className={"flex items-center justify-between"}>
      {contract.cancelledAt !== null ? <>
        <div>{contract.displayName}</div>
        <Button type={'white'} size={'sm'} icon={faRefresh} text={'Undo cancellation'} onClick={() => reactivateContract(contract)} />
      </> : <>
        <div>{contract.displayName}</div>
        <Button type={'danger'} size={'sm'} icon={faCancel} text={'Cancel'} onClick={() => cancelContract(contract)} />
      </>}
    </div>)}
  </Card>
}
